import { PortalType } from '../config/enum';

/**
 * Extracts the first subdomain from the window location hostname.
 * @returns {string} The first subdomain if present, otherwise an empty string.
 */
const getFirstSubdomain = (): string => {
  const { hostname } = window.location;

  // localhost or IP address
  if (hostname === 'localhost' || /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname)) {
    return '';
  }

  const subdomain = hostname.split('.')[0];

  const blocked = [
    'admin',
    'admin-dev',
    'admin-test',
    'localhost',
    ...Object.values(PortalType).flatMap((v) => [v, `${v}-dev`, `${v}-test`]),
  ];

  return blocked.some((d) => subdomain.includes(d)) ? '' : subdomain;
};
export default getFirstSubdomain;
